const characters =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const getRandomString = (): string => {
  return String.fromCharCode(
    ...window.crypto
      .getRandomValues(new Uint8Array(40))
      .map((element) => characters.charCodeAt(element % characters.length))
  );
};

export const lowercase = <T extends string>(value: T): Lowercase<T> => {
  return value.toLowerCase() as Lowercase<T>;
};

export const base64UrlEncode = (string: string): string => {
  return window
    .btoa(string)
    .replace(/\//g, '_')
    .replace(/\+/g, '-')
    .replace(/=+$/, '');
};

export const base64UrlDecode = (string: string): string => {
  let input = string.replace(/-/g, '+').replace(/_/g, '/');

  const pad = input.length % 4;

  if (pad === 3) {
    input += '=';
  } else if (pad === 2) {
    input += '==';
  } else if (pad === 1) {
    throw new Error('Invalid base64url string');
  }

  return window.atob(input);
};

export function pascalCaseToKebabCase(inputString: string): string {
  return inputString
    .replace(/^[A-Z]/, (letter) => letter.toLowerCase())
    .replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}
